/**
 * Builds the API payload for creating/updating a Pre-Stock Inspection (PSI) checklist.
 * Previously defined inline inside FormPreStockInspection.jsx, which made that file
 * harder to scan for its actual responsibility (rendering the form).
 *
 * @param {Object} formData - current form state
 * @param {boolean} editMode - true when editing an existing record
 * @param {Object} inspectionInfo - the original record being edited (edit mode only)
 * @param {Array} questionsWithAnswers - the original question/answer list (edit mode only), used to diff changed answers
 */
export const preparePreStockInspectionPayload = (formData, editMode, inspectionInfo, questionsWithAnswers = []) => {
    if (!editMode) {
        return {
            inspectorName: formData.inspectorName,
            inspectorTitle: formData.inspectorTitle,
            inspectionDate: formData.inspectionDate,
            stockInDate: formData.stockInDate,
            vin: formData.vin,
            notesOrOtherDamages: formData.notesOrOtherDamages || '',
            answers: formData.answers.map((item) => ({
                questionId: item.questionId,
                answer: typeof item.answer === 'number' ? item.answer : null,
                comment: item.answer !== null && item.comment?.trim() ? item.comment : null
            }))
        };
    }

    // EDIT MODE: sadece inspection alanları + değişmiş cevaplar
    const changedAnswers = formData.answers
        .filter((item) => {
            const original = questionsWithAnswers.find((q) => q.questionId === item.questionId);
            if (!original) return true;

            const answerChanged = item.answer !== original.answer;
            const commentChanged = (item.comment || '').trim() !== (original.comment || '').trim();

            return answerChanged || commentChanged;
        })
        .map((item) => ({
            id: item.answerId || 0,
            answer: typeof item.answer === 'number' ? item.answer : null,
            comment: item.answer !== null && item.comment?.trim() ? item.comment : null
        }));

    return {
        id: inspectionInfo.id,
        inspectorName: formData.inspectorName,
        inspectorTitle: formData.inspectorTitle,
        inspectionDate: formData.inspectionDate,
        stockInDate: formData.stockInDate,
        vin: formData.vin,
        notesOrOtherDamages: formData.notesOrOtherDamages || '',
        answers: changedAnswers
    };
};
